import { Link } from 'react-router-dom';
import { servicesPreview } from '../../data/content';

export default function ServicesPreview() {
  return (
    <section className="section bg-white">
      <div className="container-wide">
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-semibold text-primary uppercase tracking-wider mb-3">
            What We Do
          </span>
          <h2 className="text-headline text-text mb-4">
            Comprehensive Analytical Services
          </h2>
          <p className="text-text-light max-w-2xl mx-auto">
            From routine testing to complex method development, we deliver accurate results you can trust.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {servicesPreview.map((service, index) => (
            <div
              key={index}
              className="group card-hover p-8 text-center border border-gray-100"
            >
              <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-primary to-primary-600 rounded-2xl flex items-center justify-center shadow-glow/50 group-hover:scale-110 transition-transform duration-300">
                <img
                  src={`/images/${service.icon}`}
                  alt=""
                  className="w-8 h-8 object-contain filter brightness-0 invert"
                />
              </div>
              <h3 className="text-title text-text mb-3">
                {service.title}
              </h3>
              <p className="text-text-light text-sm leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/services"
            className="btn-secondary"
          >
            View All Services
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
}
